<template>
  <div>
    <b-row>
      <b-col cols="12">
        <div class="animated fadeIn">
          <b-row>
            <b-col sm="12">
              <div class="table-responsive-md">
                <Vuetable
                  class="table table-striped table-bordered nowrap vue-tbl"
                  ref="Vuetable"
                  :api-url="getUrl"
                  :http-options="httpOptions"
                  :fields="fields"
                  pagination-path
                  @vuetable:pagination-data="onPaginationData"
                  :append-params="moreParams"
                  :per-page="perPage"
                >
                  <template slot="actions" scope="props">
                    <div class="custom-actions">
                      <b-button
                        v-if="$can('Edit_role', 'all')"
                        class="btn btn-warning btn-sm"
                        @click="onActionClicked('permission', props.rowData)"
                      >
                        <i class="cui-note"></i> Edit
                      </b-button>
                    </div>
                  </template>
                </Vuetable>

                <b-row>
                  <b-col>
                    <div class="vuetable-pagination ui basic segment grid row">
                      <b-col cols="4">
                        <vuetable-pagination-info
                          ref="paginationInfo"
                        ></vuetable-pagination-info>
                      </b-col>
                      <b-col cols="8">
                        <vuetable-pagination
                          style="float:right;"
                          ref="pagination"
                          @vuetable-pagination:change-page="onChangePage"
                        ></vuetable-pagination>
                      </b-col>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import VuetablePagination from "@/components/vuetable/VuetablePaginationBootstrap4";
import { mapState, mapActions } from "vuex";

export default {
  name: "Roletable",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data() {
    return {
      httpOptions: {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },
        data: {}
      },
      moreParams: {},
      getUrl: process.env.VUE_APP_API_ENDPOINT + "roles",
      fields: [
        {
          name: "id",
          title: '<span class="orange glyphicon glyphicon-user"></span> #',
          sortField: "id"
        },
        {
          name: "name",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> Role Name',
          sortField: "name"
        },

        {
          name: "permissions",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> Permissions',
          callback: "getPermissions",
          width:'440px'
        },
        {
          name: "status",
          title: '<span class="orange glyphicon glyphicon-user"></span> Status',
          sortField: "status",
          callback: "activeStatus",
          html: true
        },
        {
          name: "updated_at",
          title:
            '<span class="orange glyphicon glyphicon-user"></span> Last Updated',
          sortField: "updated_at",
          width:'200px'
        },
        ,
        {
          name: "__slot:actions",
          title: '<span class="orange glyphicon glyphicon-user"></span> Action',
          width:'100px'
        }
      ],
      data: [],
      perPage: 10,
      sortOrder: [],
      filterText: ""
    };
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.Vuetable.changePage(page);
    },

    onFilterSet(filters) {
      this.moreParams = {
        id: filters.id,
        name: filters.name,
        status: filters.status
      };
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    onFilterReset() {
      this.moreParams = {};
      Vue.nextTick(() => this.$refs.Vuetable.refresh());
    },
    onActionClicked(action, data, rowIndex) {
      if (action == "permission") {
        this.$router.push({
          name: "RoleEdit",
          params: {
            role_id: data.id
          }
        });
      }
    },
    getPermissions(permissions) {
      let str = "";
      permissions.forEach(function(permission, index) {
        str +=
          '<span class="badge badge-primary badge-pill role-margin-bottom" style="padding: 0.65em 0.6em !important;">' +
          permission.name +
          "</span>";
        if (index != permissions.length - 1) {
          str += " ";
        }
      });
      return str;
    },

    activeStatus(val) {
      return val == 1
        ? "<span class='badge badge-success'>Active</span>"
        : "<span class='badge badge-danger'>Inactive</span>";
    }
  },
  watch: {
    data(newVal, oldVal) {
      this.$refs.Vuetable.refresh();
    }
  },

  mounted() {
    this.$events.$on("filter-set", eventData => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", e => this.onFilterReset());
  }
};
</script>

<style scoped>
.custom-actions{
  min-width: 60px;
}
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}

.badge {
  padding: 0.65em 0.6em !important;
}

</style>

<style>
  .role-margin-bottom{
    margin-bottom: 2px !important;
  }
</style>
